/**********************************************************
Alexander Self
8/22/17
Gang builder container: manages the routes and components
**********************************************************/

import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchTimesheetData } from '../actions/index';
import { TEAM_URLS } from '../constants';
import Tabs from '../components/tabs';


class GangBuilder extends Component {
  componentDidMount() {
    if (this.props.employees.length === 0) return this.props.fetchTimesheetData(this.props.user);
    document.title = 'Team Builder';
  }
  render() {
    return (
      <div>
        <div className="row">
          <h5>Team Builder <span className="flow-text right">{ moment().format("dddd, MMMM Do YYYY") }</span></h5><hr />
          <Tabs id={"gangs"} tabs={TEAM_URLS} level={this.props.user.level} />
        </div>
        <div>
          { this.props.children }
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    user: state.auth.user,
    authenticated: state.auth.authenticated,
    employees: state.timesheet.employees
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchTimesheetData
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(GangBuilder);



/* END */



// WEBPACK FOOTER //
// ./src/containers/team_builder.js